import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.css';
import Nav from './composants/nav';
//import './dasboard.css';
import { useParams,useNavigate } from "react-router-dom";
import {Dialog,DialogActions, Box,DialogContent, DialogContentText, DialogTitle, TextField,Stack, Container , IconButton, Button, Paper, TableRow, TableHead, TableContainer, TableCell, TableBody, Table, Tooltip, Autocomplete} from '@mui/material';
import FirstSection from './composants/AccueilSection/firstSection';
import SecondSection from './composants/AccueilSection/secondSection';
import ThirdSection from './composants/AccueilSection/thirdSection';
import PartenaireSection from './composants/AccueilSection/partenaireSection';
import CCMSection from './composants/AccueilSection/ccmSection';
import FourSection from './composants/AccueilSection/fourSection';
import FiveSection from './composants/AccueilSection/fiveSection';
import Footer from './composants/footer';
import HomeBanner from './composants/AccueilSection/banniere';
import PartenaireBookSection from './composants/BookSection/partenaireBookSection';
import FaqSection, { faqItems } from './composants/AccueilSection/faqSection';
import Seo from './composants/Seo';

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'BET-Partners',
  url: 'https://bet-partners.com',
  logo: 'https://bet-partners.com/logo512.png',
  description: "BET-Partners est la plus grande plateforme qui vous permet d'avoir de l'argent grâce aux paris sportifs sans parier.",
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};


export default function Accueil() {

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const navigate = useNavigate();
  const handleLinkClick = (link) => {
    // Ajoutez la logique pour afficher la page correspondante en fonction du lien cliqué
    // Vous pouvez utiliser une bibliothèque de routage ou gérer manuellement le contenu ici
    navigate(`/${link}`)
};

useEffect(() => {

  axios.post('https://backend.bet-partners.com/api/save-ip')
  .then(response => console.log(response.data.message))
  .catch(error => console.error(error));

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
};
window.addEventListener('resize', handleResize);

  return () => {
    window.removeEventListener('resize', handleResize);
};
}, []);
    return (
        <div>
            <Seo
              title="Programme d'affiliation paris sportifs en Afrique"
              description="BET-Partners est la plus grande plateforme qui vous permet d'avoir de l'argent grâce aux paris sportifs sans parier. Favorisons l'inclusion financière en Afrique."
              path="/"
              jsonLd={[organizationJsonLd, faqJsonLd]}
            />
            <Nav />
            <PartenaireBookSection />  
            <FirstSection />
            <SecondSection />            
            <ThirdSection />
            <CCMSection />

            <FiveSection />
            <FaqSection />
            <Footer />
        </div>
    );
  
}